<!--  https://blog.openreplay.com/make-your-web-pages-web-printer-friendly-with-css/ -->
<template>
  <div id="printpage" class="p-3 mx-auto">
    <img src="@/assets/bv-logo.svg" class="mb-2 float-right" style="width: 150px" />
    <h3 class="my-1">
      Projekt
      <strong>{{ record.ProjectName }}</strong>
      - Änderungstestat
    </h3>
    <hr class="m-0 mb-3" />
    <div class="d-print-none mb-2 mt-3">
      <b-button @click="window.print()" size="sm">
        <b-icon icon="printer" class="mr-2" />
        Drucken
      </b-button>
      <b-button @click="window.close()" class="ml-3" size="sm">
        <b-icon icon="x" class="mr-2" />
        Schließen
      </b-button>
    </div>
    <div class="row">
      <div class="col">
        <label class="text-muted d-block mb-1"><small>Projekt</small></label>
        <div>
          {{ record.ProjectName }}
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col col-4">
        <label class="text-muted d-block mb-1"><small>PÄT Nummer</small></label>
        <div>
          {{ record.Ordinal }}
        </div>
      </div>
      <div class="col col-4">
        <label class="text-muted d-block mb-1"><small>Datum</small></label>
        <div>
          {{ $utils.SQLDateToGermanDate(record.Date) }}
        </div>
      </div>
      <div class="col col-4">
        <label class="text-muted d-block mb-1"><small>Bezeichnung</small></label>
        <div>
          {{ record.DisplayName }}
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col col-12">
        <label class="text-muted d-block mb-1"><small>Beschreibung</small></label>
        <div style="white-space: pre-wrap">
          {{ record.Description }}
        </div>
      </div>
    </div>
    <h5 class="mb-1 mt-4 text-primary">Kalkulation</h5>
    <hr class="m-0 mb-3" />
    <div class="row" v-for="item in (record.BudgetParts || []).filter(x => x.description)" :key="item.description">
      <div class="col col-8">
        <span style="display: inline-block; width: 15px" />
        {{ item.description }}
      </div>
      <div class="col col-4 text-right pr-4">
        {{ item.value !== null ? $utils.formatCurrency(item.value, SettingsStore) : '-' }}
      </div>
    </div>
    <hr class="mt-0 mb-0 mr-0" style="margin-left: 19px" />
    <div class="row no-gutters ml-2">
      <div class="col col-8" style="background-color: #eee; print-color-adjust: exact">
        <span style="display: inline-block; width: 7px" />
        BUDGETBEDARF PÄT
      </div>
      <div class="col col-4 text-right pr-2" style="background-color: #eee; print-color-adjust: exact">
        <strong>
          {{
            $utils.formatCurrency(
              (record.BudgetParts || []).reduce((sum, item) => sum + parseFloat(item.value || 0), 0),
              SettingsStore
            )
          }}
        </strong>
      </div>
    </div>
    <div style="break-inside: avoid">
      <h5 class="mb-1 mt-4 text-primary">Risiko</h5>
      <hr class="m-0 mb-3" />
      <div class="row">
        <div class="col col-12">
          <label class="text-muted d-block mb-1"><small>Beschreibung</small></label>
          <div style="white-space: pre-wrap">
            {{ record.RiskDescription || '-' }}
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col col-12">
          <label class="text-muted d-block mb-1"><small>Kostenrisiko</small></label>
          <div style="white-space: pre-wrap">
            {{ $utils.formatCurrency(record.RiskAmount, SettingsStore) }}
          </div>
        </div>
      </div>
    </div>
    <div style="break-inside: avoid">
      <h5 class="mb-1 mt-4 text-primary">Terminauswirkungen</h5>
      <hr class="m-0 mb-3" />
      <div class="row">
        <div class="col col-12">
          <label class="text-muted d-block mb-1"><small>Beschreibung</small></label>
          <div style="white-space: pre-wrap">
            {{ record.ScheduleDescription || '-' }}
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col col-12">
          <label class="text-muted d-block mb-1"><small>Terminrisiko</small></label>
          <div style="white-space: pre-wrap">
            {{ record.ScheduleRisk || '-' }}
          </div>
        </div>
      </div>
    </div>
    <div style="break-inside: avoid">
      <h5 class="mb-1 mt-4 text-primary">PÄT-Entscheidung</h5>
      <hr class="m-0 mb-3" />
      <div class="row">
        <div class="col col-4">
          <label class="text-muted d-block mb-1"><small>Datum</small></label>
          <div style="white-space: pre-wrap">
            {{ $utils.SQLDateToGermanDate(record.DecisionDate, '-') }}
          </div>
        </div>
        <div class="col col-4">
          <label class="text-muted d-block mb-1"><small>Freigabebudget</small></label>
          <div>
            {{ $utils.formatCurrency(record.DecisionBudget, SettingsStore) }}
          </div>
        </div>
        <div class="col col-4">
          <label class="text-muted d-block mb-1"><small>Entscheidung</small></label>
          <div>
            {{ record.DecisionText || '-' }}
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col col-12">
          <label class="text-muted d-block mb-1"><small>Kommentar</small></label>
          <div style="white-space: pre-wrap">
            {{ record.DecisionComment || '-' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PatsService from '@/service/PatsService';
import ProjectStore from '@/store/Projects';
import SettingsStore from '@/store/Settings';
export default {
  data() {
    return {
      SettingsStore,
      window,
      afield: '',
      record: {
        Ordinal: ''
      }
    };
  },
  activated() {
    PatsService.getById(this.$router.currentRoute.params.id).then(record => {
      /* console.log(
        'zzz projects',
        
      );*/
      const project = ProjectStore.projects.find(x => x.DbId == record.ProjectId);
      record.ProjectName = project.ProjectIdentifier + ' - ' + project.Name;
      this.record = record;
      this.afield = record.Ordinal;
      this.$nextTick(() => {
        window.document.close();
        //window.print();
        //window.close();
      });
      //setTimeout(() => {}, 300);
    });
  }
};
</script>

<style>
#printpage {
  max-width: 1050px;
}
@media screen {
  #main-panel,
  #app {
    overflow: visible !important;
  }
  #printpage {
    display: block;
    overflow: visible;
  }
}
@media print {
  #main-panel,
  #app {
    overflow: visible;
  }
  body,
  html {
    margin: 0 !important;
    padding: 0 !important;
    height: 100% !important;
    width: 100% !important;
  }
  #printpage {
    display: block;
    overflow: visible !important;
  }
}
</style>
